<template><section><h2>Challenge Descriptions</h2>
<p>In the roughly twenty years that Tethys-based GAStech has been operating a natural gas production site in the island country of Kronos, it has produced remarkable profits and developed strong relationships with the government of Kronos. However, GAStech has not been as successful in demonstrating environmental stewardship.</p>
<p>In January, 2014, the leaders of GAStech are celebrating their new-found fortune as a result of the initial public offering of their very successful company. In the midst of this celebration, several employees of GAStech go missing. An organization known as the Protectors of Kronos (POK) is suspected in the disappearance, but things may not be what they seem.</p>
<p>Many of the Abila, Kronos-based employees of GAStech have company cars which are approved for both personal and business use. Those who do not have company cars have the ability to check out company trucks for business use, but these trucks cannot be used for personal business.</p>
<p>Employees with company cars are happy to have these vehicles, because the company cars are generally much higher quality than the cars they would be able to afford otherwise. However, GAStech does not trust their employees. Without the employees’ knowledge, GAStech has installed geospatial tracking software in the company vehicles. The vehicles are tracked periodically as long as they are moving.</p>
<p>This vehicle tracking data has been made available to law enforcement to support their investigation. Unfortunately, data is not available for the day the GAStech employees went missing. Data is only available for the two weeks prior to the disappearance.</p>
<p>In addition to the vehicle data, law enforcement has been given access to the personal and business credit and debit card transactions for the local GAStech employees for the two weeks preceding the kidnapping. Many of the GAStech employees also use loyalty cards to gain discounts or extra benefits at the businesses they patronize, and law enforcement has been given access to two weeks of this loyalty card data as well.</p>
<p>As a visual analytics expert assisting law enforcement, your mission is to make sense of this data to identify suspicious patterns of behavior and to prioritize which of these may be related to the missing staff members. You must cope with uncertainties that result from missing, conflicting, and imperfect data to make recommendations for further investigation.</p>
<p>Use visual analytics to analyze the available data and develop responses to the questions below. In addition, prepare a video that shows how you used visual analytics to solve this challenge. Submission instructions are available here. Entry forms are available for download below.</p>
<h2>Project Task</h2>
<ul>
<li>
<p>Describe common daily routines for GAStech employees. What does a day in the life of a typical GAStech employee look like?</p>
</li>
<li>
<p>Identify up to twelve unusual events or patterns that you see in the data. If you identify more than twelve patterns during your analysis, focus your answer on the patterns you consider to be most important for further investigation to help find the missing staff members. For each pattern or event you identify, describe</p>
<ul>
<li>
<p>What is the pattern or event you observe?</p>
</li>
<li>
<p>Who is involved?</p>
</li>
<li>
<p>What locations are involved?</p>
</li>
<li>
<p>When does the pattern or event take place?</p>
</li>
<li>
<p>Why is this pattern or event significant?</p>
</li>
<li>
<p>What is your level of confidence about this pattern or event? Why?</p>
</li>
</ul>
</li>
<li>
<p>Like most datasets, the data you were provided is imperfect, with possible issues such as missing data, conflicting data, data of varying resolutions, outliers, or other kinds of confusing data. Considering MC2 data is primarily spatiotemporal, describe how you identified and addressed the uncertainties and conflicts inherent in this data to reach your conclusions in questions MC2.1 and MC2.2.</p>
</li>
</ul>
<h2>Schedule</h2>
<ul>
<li>
<p>Fetch Dataset, analyse tasks, and make a plan to solve it (2-3 week)</p>
</li>
<li>
<p>Process data, implement analysis framework (4-7 week)</p>
</li>
<li>
<p>Mid-term inspection (8 week)</p>
</li>
<li>
<p>Implement analysis system (9-12 week)</p>
</li>
<li>
<p>Inter-team evaluation and modification (13-15 week)</p>
</li>
<li>
<p>Final inspection (16-17 week)</p>
</li>
</ul>
<h2>Resources</h2>
<ul>
<li>http://www.vacommunity.org/VAST+Challenge+2014%3A+Mini-Challenge+2</li>
</ul>
</section></template><script>export default {components:{}}</script>